export default __webpack_public_path__ + "static/media/sarfaraz_profile.db88c480.jpg";